<template>
  <div class="about">
    <p class="about-head-p">
      WHO WE ARE
      <b>我们是一家什么样的公司</b>
    </p>

    <el-row :gutter="20" style="margin:0;">
      <el-col :span="16" :offset="4">
        <div class="about-head">




            <li>
              <img src="../assets/img/4.jpg" alt="" srcset="">
              <p>
                十方星链（苏州）航天科技有限公司成立于2022年11月23日，公司总部设在江苏省苏州市相城区，在北京、日喀则等地设有分支机构。              </p>
            </li>
            <li>
              <img src="../assets/img/4.jpg" alt="" srcset="">
              <p>
                公司以建设、管理和运营我国首个中轨道（MEO）中继卫星系统为目标，全力构建“空天信息传输高速公路”，为运载器、航天器、航空器、临近空间飞行器等各类陆海空天平台提供全球测控及数传服务，致力于成为我国商业航天领域空间信息传输行业引领者。
              </p>
            </li>
            <li>
              <img src="../assets/img/4.jpg" alt="" srcset="">
              <p>
                公司核心团队来自我国GEO中继卫星系统建设管理单位，长期从事航天系统设计、建设、运维和应用服务领域工作，专业结构全面，技术底蕴深厚。先后开展了多项中轨道（MEO）中继卫星关键技术攻关，全面掌握地基测运控网设计运管、天基测运控网设计运管、高效任务规划与资源调度、星座构型评估与最优控制、卫星故障诊断与健康管理、空间态势感知与碰撞预警等关键技术，创新设计了MEO激光+微波混合链路中继卫星方案。系统设计及多项关键技术已获专利。
              </p>
            </li>
        </div>
      </el-col>
    </el-row>

    <p class="about-head-p" ref='oute1'>
      DEVELOPMENT HISTORY
      <b>发展历程</b>
    </p>

    <el-row :gutter="24" style="margin:0;">
      <el-col :span="16" :offset="4">
        <div class="about-head-img" style="margin-top:50px;">
          <img style="box-shadow:none;" src="../assets/img/5.1.png" alt="">
        </div>
      </el-col>

    </el-row>

    <p class="about-head-p">
      CORPORATE CULTURE
      <b>企业文化</b>
    </p>

    <el-row :gutter="24" style="margin:0;">
      <el-col :span="16" :offset="4">
        <div class="about-head-img">
          <img style="box-shadow:none;" src="../assets/img/5.2.png" alt="">
        </div>
      </el-col>

    </el-row>
    <p class="about-head-p" ref='oute2'>
      HONORARY AND <br>
      QUALIFICCATION
      <b>荣誉资质</b>
    </p>

    <el-row :gutter="24" style="margin:0;">
      <el-col :span="4" :offset="6">
        <div class="about-head-img">
          <img src="../assets/img/ryzz/001.png" alt="">
        </div>
      </el-col>
      <el-col :span="4">
        <div class="about-head-img">
          <img src="../assets/img/ryzz/002.png" alt="">
        </div>
      </el-col>
      <el-col :span="4">
        <div class="about-head-img">
          <img src="../assets/img/ryzz/003.png" alt="">
        </div>
      </el-col>
      <!-- <el-col :span="4">
        <div class="about-head-img">
          <img src="../assets/img/ryzz/004.png" alt="">
        </div>
      </el-col> -->
    </el-row>
    <el-row :gutter="24" style="margin:0;margin-top:10px;">
      <el-col :span="4" :offset="4">
        <div class="about-head-img">
          <img src="../assets/img/ryzz/005.png" alt="">
        </div>
      </el-col>
      <el-col :span="4">
        <div class="about-head-img">
          <img src="../assets/img/ryzz/006.png" alt="">
        </div>
      </el-col>
      <el-col :span="4">
        <div class="about-head-img">
          <img src="../assets/img/ryzz/007.png" alt="">
        </div>
      </el-col>
      <el-col :span="4">
        <div class="about-head-img">
          <img src="../assets/img/ryzz/008.png" alt="">
        </div>
      </el-col>

    </el-row>

  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {

    };
  },
  mounted () {
    var element=0
    if(this.$route.query.id==1){
       element = this.$refs.oute1;
    }else if(this.$route.query.id==2){
       element = this.$refs.oute2;
    }
      if (element) {
        setTimeout(() => {
          const rect = element.getBoundingClientRect();
        const distanceToTop = rect.top + window.scrollY; // 计算距离顶部的距离
        this.$bus.$emit("clearKeyword",distanceToTop);
        }, 500);
      }
    },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.about {
 .about-head{
  li{
    margin-bottom:20px;
    img{
      height:30px;
    }
    display: flex;
    p{
      padding-right:20px;
      padding-left:20px;
      color:#343434;
    }
  }
 }
.about-head-p{
  margin-bottom:50px;
  text-align: center;
  font-size:80px;
  line-height: 80px;
  font-weight: 800;
  position: relative;
  color:#e8f5ec;
  margin-top:50px;
  b{
    transform: translate(-50%, -50%);
    position: absolute;
    left:50%;
    top:50%;
    font-size:24px;
    color:#343434;
    display: block;
    line-height:60px;
  }
}
.about-head-img{
  width:100%;
  img{
    width:100%;
    box-shadow: 0 0 5px 5px #ccc;
  }
}
}
// 响应式
@media only screen and (max-width: 767px) {

}
</style>
